import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Course, Match, PlayerResult, UpdateStatus } from '../../../../database.schema';
import { useTournamentResultScoreCardMutation } from '../../../api/tournament-data';
import { Button } from '../../common-styles/common-styles';
import { calculateOveralMatchResult, calculateScore, getPlayerScore, getTeamPoints } from '../../../utils/score-calculator';

type UpdateButtonProps = {
  course: Course;
  startingHole: number;
  selectedTournamentIndex: number;
  resultIndex: number;
  matchIndex: number;
  recordedMatch: Match;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ selectedTournamentIndex, resultIndex, course, startingHole, recordedMatch, matchIndex, setUpdateStatus }) => {
  const navigate = useNavigate();
  const mutation = useTournamentResultScoreCardMutation();
  const saveScorecard = () => {
    const finishedRecordedMatch = { ...recordedMatch };

    finishedRecordedMatch.resultMargin = calculateOveralMatchResult(recordedMatch.resultByHole).substring(3);
    finishedRecordedMatch.team1.points = getTeamPoints('team1', recordedMatch.resultByHole) as 0 | 0.5 | 1;
    finishedRecordedMatch.team2.points = getTeamPoints('team2', recordedMatch.resultByHole) as 0 | 0.5 | 1;
    finishedRecordedMatch.team1.players.forEach((player: PlayerResult) => {
      if (finishedRecordedMatch.team1.points === 1) {
        player.won = 1;
      } else if (finishedRecordedMatch.team1.points === 0.5) {
        player.halved = 1;
      } else {
        player.lost = 1;
      }
      player.points = getPlayerScore(player.round.individualHandicap, player.round.scoreCard, course, startingHole);
    });
    finishedRecordedMatch.team2.players.forEach((player: PlayerResult) => {
      if (finishedRecordedMatch.team2.points === 1) {
        player.won = 1;
      } else if (finishedRecordedMatch.team2.points === 0.5) {
        player.halved = 1;
      } else {
        player.lost = 1;
      }
      player.points = getPlayerScore(player.round.individualHandicap, player.round.scoreCard, course, startingHole);
    });
    finishedRecordedMatch.status = 'complete';

    const dataToSave = { selectedTournamentIndex, resultIndex, recordedMatch: { ...finishedRecordedMatch }, matchIndex };
    if (dataToSave) {
      mutation.mutate(
        { ...dataToSave },
        {
          onSuccess: (data) => {
            navigate(`/edit-results/${selectedTournamentIndex}/${resultIndex}`);
          },
          onError: (error) => {
            setUpdateStatus({ success: false, error: true });
            console.log('<><><>ERROR<><><><', error);
          },
        }
      );
    }
    navigate(`/edit-results/${selectedTournamentIndex}/${resultIndex}`);
  };
  return (
    <Button data-testid="save-scorecard" onClick={() => saveScorecard()} disabled={!recordedMatch}>
      Save
    </Button>
  );
};
